module.exports = __webpack_public_path__ + "img/weixin1-03.be865b9f.png";